import {
  CategoriesRepositoryContract,
  CategoryEntity,
  ListCategoriesParams,
} from "@features/categories/domain";
import { country } from "@features/country/data";
import { BaseRepository } from "@features/shared/data";
import { categoriesUrls } from "../constants";
import { mapCategory } from "../mappers";
import { CategoryModel } from "../models";

export class CategoriesRepository
  extends BaseRepository
  implements CategoriesRepositoryContract
{
  public async list(params: ListCategoriesParams): Promise<CategoryEntity[]> {
    return this.cacheable(
      this.cacheKey("categories", {
        params,
        country: country.code,
      }),
      async () => {
        const { data } = await this.http.get<CategoryModel[]>(
          categoriesUrls.GET_CATEGORIES_URL,
          {
            params,
          },
        );

        return data.map(mapCategory);
      },
    );
  }
}
